import produce from 'immer';

import { GET_FINANCE_REPORT_LIST_FAILURE, GET_FINANCE_REPORT_LIST_SUCCESS } from '@actions/financeReport';

const initialState: IFinanceReportStore = {
  financeReportList: null,
  error: null,
};

export default (state: IFinanceReportStore = initialState, action: any) =>
  produce(state, (draftState: IFinanceReportStore) => {
    switch (action.type) {
      case GET_FINANCE_REPORT_LIST_SUCCESS:
        draftState.financeReportList = action.response;
        draftState.error = null;

        return;

      case GET_FINANCE_REPORT_LIST_FAILURE:
        draftState.error = action.error;

        return;

        return;
    }
  });
